export default __webpack_public_path__ + "static/media/basic-app-bars.888f97de.png";